import { piChatPanelWidthLocalStorage } from 'storage/components';

export const AI_PANEL_DEFAULT_WIDTH = 480;
export const AI_PANEL_MIN_WIDTH = 360;
const AI_PANEL_MAX_WIDTH = 900;
const AI_PANEL_MAX_VIEWPORT_SHARE = 0.6;

export const KEYBOARD_STEP_PX = 16;
export const KEYBOARD_LARGE_STEP_PX = 64;

export const maxPanelWidth = (viewportWidth: number) =>
  Math.max(
    AI_PANEL_MIN_WIDTH,
    Math.min(
      AI_PANEL_MAX_WIDTH,
      Math.floor(viewportWidth * AI_PANEL_MAX_VIEWPORT_SHARE)
    )
  );

export const clampPanelWidth = (width: number, viewportWidth: number) =>
  Math.round(
    Math.min(maxPanelWidth(viewportWidth), Math.max(AI_PANEL_MIN_WIDTH, width))
  );

export const readStoredPanelWidth = (viewportWidth: number): number =>
  clampPanelWidth(
    piChatPanelWidthLocalStorage.val ?? AI_PANEL_DEFAULT_WIDTH,
    viewportWidth
  );

export const writeStoredPanelWidth = (width: number) => {
  piChatPanelWidthLocalStorage.val = Math.round(width);
};

export const keyboardResize = (
  key: string,
  shiftKey: boolean,
  width: number,
  viewportWidth: number
): number | null => {
  const step = shiftKey ? KEYBOARD_LARGE_STEP_PX : KEYBOARD_STEP_PX;
  switch (key) {
    case 'ArrowLeft':
      return clampPanelWidth(width + step, viewportWidth);
    case 'ArrowRight':
      return clampPanelWidth(width - step, viewportWidth);
    case 'Home':
      return clampPanelWidth(AI_PANEL_MIN_WIDTH, viewportWidth);
    case 'End':
      return maxPanelWidth(viewportWidth);
    default:
      return null;
  }
};
